<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params.data &&
            params.data.remarks
          "
          color="error"
          v-on="on"
          v-bind="attrs"
          @click="openRemarksDialog"
        >
          mdi-information
        </v-icon>
      </template>
      <span>View Remarks</span>
    </v-tooltip>
  </div>
</template>
  <script>
export default {
  methods: {
    openRemarksDialog() {
      this.$root.$confirm("Remarks", `${this.params.data.remarks}`, {
        color: "error",
        hasActions: false,
      });
    },
  },
};
</script>
  